import EnhancedContentRecord from "models/view-models/enhanced-content-record";
import ServiceFactory from "../service-factory";
import ServiceHookFactory from "../service-hook-factory";

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "enhanced-contents/details";

interface EnhancedContentDetailsBasePathParams {
    id: number;
}

interface EnhancedContentDetailsQueryParams {
    ids: [];
}
const resourceEndpoint = `${baseEndpoint}/:id`;

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------
const EnhancedContentDetailsService = {
    get: ServiceFactory.get<
        EnhancedContentRecord,
        EnhancedContentDetailsBasePathParams
    >(EnhancedContentRecord, resourceEndpoint),
    list: ServiceFactory.nestedList<
        EnhancedContentRecord,
        EnhancedContentDetailsBasePathParams,
        EnhancedContentDetailsQueryParams
    >(EnhancedContentRecord, baseEndpoint),

    useList: ServiceHookFactory.useList<
        EnhancedContentRecord,
        EnhancedContentDetailsQueryParams
    >(EnhancedContentRecord, baseEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default EnhancedContentDetailsService;

// #endregion Exports
